import { render, staticRenderFns } from "./ExcluirPedidoManutencao.vue?vue&type=template&id=90367b42&scoped=true&"
import script from "./ExcluirPedidoManutencao.vue?vue&type=script&lang=js&"
export * from "./ExcluirPedidoManutencao.vue?vue&type=script&lang=js&"
import style0 from "./ExcluirPedidoManutencao.vue?vue&type=style&index=0&id=90367b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90367b42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
